import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import CardMoreButton from '@/components/CardMoreButton.vue';
import apis from '@/apis/documentApi';

var Document = /*#__PURE__*/function (_Vue) {
  _inherits(Document, _Vue);

  var _super = _createSuper(Document);

  function Document() {
    _classCallCheck(this, Document);

    return _super.apply(this, arguments);
  }

  _createClass(Document, [{
    key: "handleToDetail",
    value: function handleToDetail() {
      this.$router.push({
        name: 'CaseInfo',
        params: {
          id: this.caseId
        }
      });
    }
  }, {
    key: "handleBackToTrial",
    value: function handleBackToTrial() {
      var _this = this;

      this.$confirm('退回重审后需要重新排期，确定退回吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question',
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    apis.changeTrialStatus({
                      caseId: _this.caseId
                    }).then(function () {
                      _this.$message.success('退回重审成功');

                      _this.backToTrialSuccess(_this.caseId);

                      _this.$refs.pagedTable.reload();
                    }).catch(function (_) {});

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }

          return onConfirm;
        }(),
        onCancel: function onCancel() {}
      });
    } // 退回重审

  }, {
    key: "backToTrialSuccess",
    value: function backToTrialSuccess(caseId) {}
  }]);

  return Document;
}(Vue);

__decorate([Prop({
  type: String
})], Document.prototype, "caseNoAll", void 0);

__decorate([Prop({
  type: String
})], Document.prototype, "caseName", void 0);

__decorate([Prop({
  type: String
})], Document.prototype, "caseTypeName", void 0);

__decorate([Prop({
  type: String
})], Document.prototype, "registerTime", void 0);

__decorate([Prop({
  type: String
})], Document.prototype, "undertakerPersonName", void 0);

__decorate([Prop({
  type: String
})], Document.prototype, "caseReasonName", void 0);

__decorate([Prop({
  type: String
})], Document.prototype, "caseId", void 0);

__decorate([Prop({
  type: Object || undefined
})], Document.prototype, "hightLight", void 0);

Document = __decorate([Component({
  components: {
    CardMoreButton: CardMoreButton
  }
})], Document);
export default Document;